import { GetBrandBySlugViewModel, GetCategoryBySlugViewModel, ProductListSort } from '@/types/api'
import { CombinationSlugPageViewModel, TagViewModel } from '@/types/cml-api'

import { PLPBasicMetasProps, PLPPages, PurePLPBasicMetasProps } from '../types'

export function isCategoryMetas(
    page: PLPPages,
    metas: PLPBasicMetasProps | undefined
): metas is GetCategoryBySlugViewModel {
    return typeof metas === 'object' && metas !== null && page === PLPPages.Categories
}

export function isBrandMetas(page: PLPPages, metas: PLPBasicMetasProps | undefined): metas is GetBrandBySlugViewModel {
    return typeof metas === 'object' && metas !== null && page === PLPPages.Brands
}

export function isTagMetas(page: PLPPages, metas: PLPBasicMetasProps | undefined): metas is TagViewModel {
    return typeof metas === 'object' && metas !== null && page === PLPPages.Tags
}

// use for facets and brand-categories combination pages
export function isCombinationMetas(
    page: PLPPages,
    metas: PLPBasicMetasProps | undefined
): metas is CombinationSlugPageViewModel {
    return (
        typeof metas === 'object' &&
        metas !== null &&
        (page === PLPPages.BrandCategoriesCombination || page === PLPPages.Facets)
    )
}

export function isPurePLPMetas(metas: PLPBasicMetasProps | undefined): metas is PurePLPBasicMetasProps {
    return (
        typeof metas === 'object' &&
        metas !== null &&
        !('brand' in metas && 'category' in metas) && // not a brand-category combination
        ('description' in metas || 'nameFa' in metas || 'nameEn' in metas)
    )
}

export function isValidProductListSort(value: string | string[] | undefined | null): value is ProductListSort {
    if (!value || typeof value !== 'string') return false
    // Using 'as' here is OK because we're checking if `value` is one of the allowed enum values,
    // so casting to ProductListSort is safe for the includes check.
    return Object.values(ProductListSort).includes(value as ProductListSort)
}
